/* eslint-disable react/jsx-props-no-spreading */
import AddIcon from '@mui/icons-material/Add'
import Close from '@mui/icons-material/Close'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import Edit from '@mui/icons-material/Edit'
import ExitToApp from '@mui/icons-material/ExitToApp'
import Inbox from '@mui/icons-material/Inbox'
import Mail from '@mui/icons-material/Mail'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined'
import ReplayIcon from '@mui/icons-material/Replay'
import VpnKey from '@mui/icons-material/VpnKey'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

// Local SVG imports as React components
import { ReactComponent as IconProfile } from 'src/assets/images/svg/icon-profile.svg'
import { ReactComponent as IconRoundCheckFilled } from 'src/assets/images/svg/icon-round-check-filled.svg'
import { ReactComponent as IconCloseRoundedFilled } from 'src/assets/images/svg/icon-close-rounded-filled.svg'
import { ReactComponent as IconUserFilled } from 'src/assets/images/svg/icon-user.svg'
import { ReactComponent as IconHelp } from 'src/assets/images/svg/icon-help.svg'
import { ReactComponent as IconExchange } from 'src/assets/images/svg/icon-exchange.svg'
import { ReactComponent as IconCloseRounded } from 'src/assets/images/svg/icon-close-rounded.svg'
import { ReactComponent as IconRoundCheck } from 'src/assets/images/svg/icon-round-check.svg'

type IconProps = {
  className?: string
  color?: string
  size?: number
}

type IconPropsSvgUse = {
  color: string
  width: number
  height: number
}

const createMuiIcon = (Component: any) => ({ className, color, size }: IconProps) => (
  <Component style={{ color, fontSize: size }} className={className} />
)

export const EditIcon = createMuiIcon(Edit)
export function EditLxIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <rect x="0" y="209.5" width="256" height="15.1" />
      <g>
        <path
          d="M96.7,148.7L223.1,23.2L256,55.9L129.6,181.5l-49.4,16.3L96.7,148.7z M109.9,156.8l-5.8,17.2l17.3-5.7
          l4.6-4.5l-11.6-11.5L109.9,156.8z M125.1,141.7l11.5,11.5L212.4,78l-11.6-11.5L125.1,141.7z M211.5,55.9l11.5,11.5l11.5-11.5
          l-11.5-11.5L211.5,55.9z"
        />
      </g>
    </SvgIcon>
  )
}
export const CloseIcon = createMuiIcon(Close)
export const ConnectionIcon = createMuiIcon(OfflineBoltOutlinedIcon)

export function DownloadIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M2 18.8251V6.15678H8.37471V7.22029H3.07408V17.7623H18.9266V7.22029H13.6253V6.15678H20V18.8251H2Z" />
      <path d="M8.41347 12.2876L9.16265 11.5455L10.47 12.8409V3.17487H11.53V12.8409L12.8374 11.5455L13.5865 12.2876L11 14.8495L8.41347 12.2876Z" />
    </SvgIcon>
  )
}

export const EmailIcon = createMuiIcon(Mail)

export function EmailOpenIcon(props: SvgIconProps): JSX.Element {
  return (
    <svg {...props} x="0px" y="0px" viewBox="0 0 256 256" enableBackground="new 0 0 256 256">
      <path
        fill="#001978"
        d="M128-0.1L0,75.2V79v1.8V256h256V79.9V79v-3.2L128-0.1z M239.2,84.7L128,180.3L27.7,94h0.1L17,84.7L128,18
	      L239.2,84.7z M15,102.8l73.1,62.9L15,228.6V102.8z M23.6,241l75.9-65.4l28.4,24.5l28.4-24.5l75.9,65.4H23.6z M241,228.6l-73.1-62.9
	      l73.1-62.9V228.6z"
      />
    </svg>
  )
}
export function EmailCloseIcon(props: SvgIconProps): JSX.Element {
  return (
    <svg {...props} viewBox="0 0 256 256">
      <path
        fill="#10216f"
        d="M0,39.5v177H256V39.5Zm228.29,15L128,140.84,27.71,54.5ZM15,63.35l73.06,62.9L15,189.14ZM23.64,201.5l75.91-65.36L128,160.63l28.45-24.49,75.91,65.36ZM241,189.14l-73.06-62.89L241,63.35Z"
      />
    </svg>
  )
}
export const NextIcon = createMuiIcon(NavigateNextIcon)
export function FolderIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M143.76,68.15,130.92,52.69H241V68.15Zm97.24,151H15V42.51h88l33.75,40.64H241ZM118.47,37.69,110,27.51H0V234.15H256V37.69Z" />
    </SvgIcon>
  )
}
export const InboxIcon = createMuiIcon(Inbox)
export const LefebvreIcon = createMuiIcon(DescriptionOutlinedIcon)
export const LogoutIcon = createMuiIcon(ExitToApp)
export function PdfIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M83.12,121.21H63.06v51.41H75.79v-20h7.33c10.35,0,18.16-6.75,18.16-15.7a14.47,14.47,0,0,0-4.35-10.32A19.48,19.48,0,0,0,83.12,121.21Zm5.16,15.7c0,3.06-2.06,4.81-5.65,4.81H75.79v-9.61h6.84C87.69,132.11,88.28,134.85,88.28,136.91Z" />
      <path d="M125.75,121.21H105.48v51.41h20.34c14.76,0,26.31-11.31,26.31-25.74C152.13,132.72,140.3,121.21,125.75,121.21Zm13.38,25.68c0,8.19-6,14.85-13.38,14.85h-7.54V132.11h7.54C133.38,132.11,139.13,138.46,139.13,146.89Z" />
      <polygon points="192.94 132.11 192.94 121.21 157.74 121.21 157.74 172.63 170.46 172.63 170.46 151.84 188.16 151.84 188.16 140.95 170.46 140.95 170.46 132.11 192.94 132.11" />
      <path d="M169.55,0H24.68V256H231.32V61.77Zm4.37,57.4V25.47L205.83,57.4Zm42.47,14.92V241.08h-176V14.92H159v57.4Z" />
    </SvgIcon>
  )
}
export function DocumentIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M169.56,0H24.65V256h206.7V61.78ZM174,25.92l31.41,31.42H174ZM40.62,240.81V15.19h118.2V72.52h57.34v51.79h-.69v15h.69v101.5Z" />
      <rect x="74.29" y="108.48" width="108.26" height="15.12" />
      <rect x="74.29" y="139.4" width="108.26" height="15.12" />
      <rect x="73.87" y="171.81" width="108.26" height="15.12" />
    </SvgIcon>
  )
}

export const NewIcon = createMuiIcon(AddIcon)
export function AddLxIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="256.01 120.5 135.5 120.5 135.5 -0.01 120.5 -0.01 120.5 120.5 -0.01 120.5 -0.01 135.5 120.5 135.5 120.5 256.01 135.5 256.01 135.5 135.5 256.01 135.5 256.01 120.5" />
    </SvgIcon>
  )
}

export const ReloadIcon = createMuiIcon(ReplayIcon)
export const SignIcon = createMuiIcon(VpnKey)
export function UserIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M158 129.78l-1.7-.51 1.59-.79a67.39 67.39 0 10-61.08-.69l1.55.81-1.69.48c-39.87 11.31-80.23 47.13-80.23 93.69v32.53h223.15v-32.53c0-45.01-41.06-80.85-81.59-92.99zM75.56 68.09A52.44 52.44 0 11128 120.53a52.5 52.5 0 01-52.44-52.44zm149.09 172.27H31.35v-17.59c0-21.52 10.76-42.35 30.29-58.66 18.47-15.43 41.89-24.28 64.26-24.28 44.73 0 98.75 37 98.75 82.94z" />
    </SvgIcon>
  )
}

export function LexonIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 66.13 66.4">
      <polygon points="39.69 0 0 0 0 59.59 6.62 59.59 6.62 6.8 39.69 6.8 39.69 0" />
      <polygon points="66.13 6.8 59.5 6.8 59.5 59.59 26.44 59.59 26.44 66.4 66.13 66.4 66.13 6.8" />
      <path d="M32.41,43.51v4.78H13.31V18.11h5v25.4Z" />
      <polygon points="48.12 39.52 53.83 32.12 48.88 32.12 45.71 36.58 42.54 32.12 37.6 32.12 43.26 39.52 36.73 48.12 37.74 48.12 41.52 48.12 41.79 48.12 45.71 42.48 49.64 48.12 49.9 48.12 53.69 48.12 54.7 48.12 48.12 39.52" />
    </SvgIcon>
  )
}

export function LexnetIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M158.86,122.51c0,25.45,21.79,46.16,48.57,46.16S256,148,256,122.51v-1.37L219,32.81h29.58V18.17H152.24l-1.05-2.27a25.92,25.92,0,0,0-46.44,0l-1,2.27H7.41V32.81H37.06L0,121.14v1.37C0,148,21.79,168.67,48.57,168.67S97.14,148,97.14,122.51v-1.37L60.08,32.81h43.65l1,2.27a24.77,24.77,0,0,0,13,12.38l2.4,1,0,143H95.7v24.84H65.39V191.41H.8V256H65.39V231.16H95.7V256h64.59V231.16H190.6V256h64.6V191.41H190.6v24.84H160.29V191.41H135.85v-143l2.4-1a24.75,24.75,0,0,0,13-12.37l1.05-2.27H196l-37.09,88.36Zm-80.34,12.9C73.2,146.64,61.44,154,48.54,154a33.33,33.33,0,0,1-29.92-18.62L16,129.83h65.2Zm-.79-20.21H19.37l29.2-69.6ZM50.48,241.1H15.7V206.32H50.48Zm155-34.78h34.78V241.1H205.51ZM145.38,241.1H110.61V206.32h34.77ZM128,36.8a11.38,11.38,0,1,1,11.37-11.38A11.39,11.39,0,0,1,128,36.8Zm79.43,8.81,29.2,69.59h-58.4ZM240,129.83l-2.65,5.58c-5.32,11.23-17.08,18.54-30,18.62a33.33,33.33,0,0,1-29.92-18.62l-2.65-5.58Z" />
    </SvgIcon>
  )
}

export function LexnetIcon2(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M11.9725 9.60118C11.9725 11.228 13.3653 12.5518 15.0771 12.5518C16.7889 12.5518 18.1818 11.2305 18.1818 9.60118V9.51361L15.8167 3.86752H17.7075V2.93172H11.5494L11.4822 2.78662C11.3451 2.51019 11.1335 2.27754 10.8713 2.1149C10.609 1.95225 10.3066 1.86608 9.99802 1.86608C9.68944 1.86608 9.38699 1.95225 9.12475 2.1149C8.86252 2.27754 8.65091 2.51019 8.51378 2.78662L8.44986 2.93172H2.29177V3.86752H4.18701L1.81812 9.51361V9.60118C1.81812 11.2305 3.21094 12.5518 4.92273 12.5518C6.63452 12.5518 8.02735 11.2305 8.02735 9.60118V9.51361L5.65846 3.86752H8.44858L8.51251 4.01262C8.6808 4.37102 8.97728 4.65335 9.34347 4.80395L9.49688 4.86787V14.0085H7.9353V15.5963H5.99787V14.0053H1.86925V18.1339H5.99787V16.5461H7.9353V18.1339H12.0639V16.5461H14.0014V18.1339H18.1306V14.0053H14.0014V15.5931H12.0639V14.0053H10.5017V4.86468L10.6551 4.80076C11.0213 4.65042 11.3178 4.36829 11.4861 4.01006L11.5532 3.86496H14.3465L11.9757 9.51297L11.9725 9.60118ZM6.83715 10.4258C6.49709 11.1436 5.74539 11.614 4.92081 11.614C4.52266 11.6142 4.13244 11.5027 3.7944 11.2924C3.45636 11.082 3.18404 10.7811 3.00831 10.4238L2.84084 10.0691H7.00846L6.83715 10.4258ZM6.78665 9.13392H3.05625L4.92273 4.68506L6.78665 9.13392ZM5.04482 17.1815H2.82167V14.9584H5.04482V17.1815ZM14.9525 14.9584H17.1756V17.1815H14.9544L14.9525 14.9584ZM11.1109 17.1815H8.88836V14.9584H11.1109V17.1815ZM9.99993 4.12256C9.85604 4.12269 9.71534 4.08013 9.59563 4.00028C9.47592 3.92043 9.38259 3.80686 9.32743 3.67396C9.27228 3.54105 9.25778 3.39477 9.28578 3.25362C9.31377 3.11248 9.383 2.98281 9.48471 2.88101C9.58641 2.77922 9.71602 2.70987 9.85715 2.68175C9.99827 2.65363 10.1446 2.668 10.2775 2.72304C10.4105 2.77808 10.5241 2.87131 10.6041 2.99095C10.684 3.11058 10.7267 3.25125 10.7267 3.39514C10.7265 3.5879 10.6499 3.77273 10.5137 3.90909C10.3775 4.04545 10.1927 4.12222 9.99993 4.12256ZM15.0771 4.6857L16.9436 9.13392H13.2107L15.0771 4.6857ZM17.159 10.0691L16.9896 10.4258C16.6496 11.1436 15.8979 11.6108 15.072 11.616C14.6739 11.6161 14.2836 11.5047 13.9456 11.2943C13.6076 11.0839 13.3352 10.783 13.1595 10.4258L12.9901 10.0691H17.159Z" />
    </SvgIcon>
  )
}

export function DeleteIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="22" height="23" viewBox="0 0 22 23" fill="none">
      <path d="M8.01172 10.6309H9.06641V17.6875H8.01172V10.6309Z" />
      <path d="M13.9883 10.626H12.9336V17.6826H13.9883V10.626Z" />
      <path d="M10.4727 10.6309H11.5273V17.6875H10.4727V10.6309Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36328 4.64453V2.5H13.6367V4.64453H17.8555V8.86328H16.8008V20.5H5.19922V8.86328H4.14453V4.64453H8.36328ZM5.19922 7.80859H16.8008V5.69922H5.19922V7.80859ZM6.25391 19.4453H15.7461V8.86328H6.25391V19.4453ZM12.582 3.55469H9.41797V4.64453H12.582V3.55469Z"
      />
    </SvgIcon>
  )
}

export function WarningIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <rect x="120.5" y="192.48" width="15" height="15" />
      <path d="M136,208H120V192h16Zm-15-1h14V193H121Z" />
      <rect x="120.5" y="93.97" width="15" height="84.65" />
      <path d="M136,179.12H120V93.47h16Zm-15-1h14V94.47H121Z" />
      <path d="M128,17.15,0,238.85H256Zm0,30,102,176.7H26Z" />
    </SvgIcon>
  )
}

export function WarningIcon2(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10.5113 13.2676H9.48857V7.79278H10.5113V13.2676Z" />
      <path d="M10.5113 14.0909V15.1136H9.48857V14.0909H10.5113Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.81812 17.0856L9.99993 2.91442L18.1818 17.0856H1.81812ZM16.5198 16.1268L9.99993 4.83203L3.48005 16.1268H16.5198Z"
      />
    </SvgIcon>
  )
}

export function WarningFillIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
      <path d="M16 3.87578L2 28.1242H30L16 3.87578ZM16.875 24.7445H15.125V22.9945H16.875V24.7445ZM15.125 21.5836V12.2211H16.875V21.5836H15.125Z" />
    </SvgIcon>
  )
}

export function CheckIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="56.05 137.75 66.7 127.1 103.96 164.36 197.99 70.34 208.64 80.99 103.96 185.66 56.05 137.75" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function SimpleCheckIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="0.71 144.91 11.52 134.1 80.35 202.93 245.67 37.61 256.48 48.42 80.35 224.55 0.71 144.91" />
    </SvgIcon>
  )
}

export function CheckFillIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      <path d="M16 2C8.26719 2 2 8.26719 2 16C2 23.7328 8.26719 30 16 30C23.7328 29.9891 29.9891 23.7328 30 16C30 8.26719 23.7328 2 16 2ZM13.375 22.3109L8.13594 17.0719L9.29531 15.9016L13.375 19.9812L23.6562 9.7L24.8266 10.8594L13.375 22.3109Z" />
    </SvgIcon>
  )
}

export function CloseRoundIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
      <rect
        x="120.5"
        y="45.58"
        width="15"
        height="164.83"
        transform="translate(-53.02 128) rotate(-45)"
      />
      <rect
        x="120.5"
        y="45.58"
        width="15"
        height="164.83"
        transform="translate(128 -53.02) rotate(45)"
      />
    </SvgIcon>
  )
}

export function LfCloseIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M14 3.09091L12.9091 2L8 6.90909L3.09091 2L2 3.09091L6.90909 8L2 12.9091L3.09091 14L8 9.09091L12.9091 14L14 12.9091L9.09091 8L14 3.09091Z" />
    </SvgIcon>
  )
}

export function CloseRoundFullIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22" fill="none">
      <path d="M11 2C6.02891 2 2 6.02891 2 11C2 15.9711 6.02891 20 11 20C15.9711 19.993 19.993 15.9711 20 11C20 6.02891 15.9711 2 11 2ZM15.4719 14.7266L14.7266 15.4719L11 11.7453L7.27344 15.4719L6.52812 14.7266L10.2547 11L6.52812 7.27344L7.27344 6.52812L11 10.2547L14.7266 6.52812L15.4719 7.27344L11.7453 11L15.4719 14.7266Z" />
    </SvgIcon>
  )
}

export function SearchIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M13.1362 2C11.8262 1.9996 10.5436 2.37494 9.44043 3.08151C8.33729 3.78808 7.45996 4.79623 6.91249 5.98637C6.36503 7.17651 6.17041 8.4987 6.35171 9.79611C6.53302 11.0935 7.08264 12.3117 7.93539 13.3062L7.22261 14.0197L6.47612 13.2746L2.01123 17.7633L4.24719 20L8.71207 15.5105L7.96769 14.7662L8.68258 14.0534C9.52131 14.7717 10.5213 15.2767 11.5973 15.5252C12.6733 15.7736 13.7934 15.7583 14.8622 15.4805C15.931 15.2027 16.9168 14.6706 17.7355 13.9296C18.5543 13.1886 19.1818 12.2606 19.5646 11.2247C19.9473 10.1889 20.074 9.07581 19.9337 7.98044C19.7935 6.88507 19.3905 5.83984 18.7591 4.93382C18.1278 4.02779 17.2867 3.28783 16.3076 2.777C15.3286 2.26616 14.2405 1.99959 13.1362 2ZM4.24508 18.507L3.49999 17.7612L6.47822 14.7676L7.22331 15.5126L4.24508 18.507ZM13.1362 14.6517C11.9895 14.6515 10.8685 14.3114 9.91505 13.6742C8.9616 13.037 8.21851 12.1314 7.77972 11.0719C7.34094 10.0124 7.22617 8.84656 7.44993 7.72184C7.67368 6.59711 8.22592 5.56399 9.03681 4.7531C9.84769 3.94222 10.8808 3.38998 12.0055 3.16623C13.1303 2.94247 14.2961 3.05724 15.3556 3.49602C16.4151 3.93481 17.3207 4.6779 17.9579 5.63134C18.5951 6.58479 18.9352 7.70576 18.9354 8.85253C18.9339 10.3901 18.3224 11.8643 17.2352 12.9515C16.148 14.0387 14.6738 14.6502 13.1362 14.6517Z" />
    </SvgIcon>
  )
}

export function FirstPageIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 23 23">
      <path d="M14.0434 3.24567L13.2984 2.5L4.30264 11.4873L4.31037 11.4958L4.30264 11.5042L13.2984 20.4916L14.0434 19.7459L5.78554 11.4958L14.0434 3.24567Z" />
      <path d="M18.6973 3.25411L17.9524 2.50844L8.9566 11.4958L8.96504 11.5042L8.9566 11.5127L17.9524 20.5L18.6973 19.7543L10.4395 11.5042L18.6973 3.25411Z" />
    </SvgIcon>
  )
}

export function LastPageIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 23 23">
      <path d="M8.95663 19.7543L9.7023 20.5L18.6974 11.5127L18.6896 11.5042L18.6974 11.4958L9.7023 2.50844L8.95663 3.25411L17.2145 11.5042L8.95663 19.7543Z" />
      <path d="M4.30267 19.7459L5.04764 20.4916L14.0434 11.5042L14.035 11.4958L14.0434 11.4873L5.04764 2.5L4.30267 3.24567L12.5605 11.4958L4.30267 19.7459Z" />
    </SvgIcon>
  )
}

export function AngleLeftIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M15.8728 2.74602L15.1274 2L6.12744 10.9916L6.13518 11L6.12744 11.0084L15.1274 20L15.8728 19.254L7.61104 11L15.8728 2.74602Z" />
    </SvgIcon>
  )
}

export function AngleRightIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M15.8728 10.9916L6.87275 2L6.12744 2.74602L14.3892 11L6.12744 19.254L6.87275 20L15.8728 11.0084L15.865 11L15.8728 10.9916Z" />
    </SvgIcon>
  )
}

export function AngleDownIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="256 69.3 245.39 58.7 128 176.2 10.61 58.7 0 69.3 127.88 197.3 128 197.19 128.12 197.3 256 69.3" />
    </SvgIcon>
  )
}

export function AngleDownIcon2(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M18.1818 6.24787L17.5036 5.57031L9.99999 13.081L2.49637 5.57031L1.81818 6.24787L9.99232 14.4297L9.99999 14.4227L10.0077 14.4297L18.1818 6.24787Z" />
    </SvgIcon>
  )
}

export function AngleUpIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="256 186.7 128.12 58.7 128 58.81 127.88 58.7 0 186.7 10.61 197.3 128 79.8 245.39 197.3 256 186.7" />{' '}
    </SvgIcon>
  )
}

export function TrashIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M210.5,75.5H45.5v-30h165ZM195.5,241H60.5V90.5h135Zm-90-226h45V30.5h-45ZM90.5,0V30.5h-60v60h15V256h165V90.5h15v-60h-60V0Z" />
      <rect x="85.5" y="115.64" width="15" height="100.36" />
      <rect x="155.5" y="115.57" width="15" height="100.36" />
      <rect x="120.5" y="115.64" width="15" height="100.36" />
    </SvgIcon>
  )
}

export function InfoIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M11.6462 6.43882H10.3546V7.73046H11.6462V6.43882Z" />
      <path d="M11.6806 7.76562H10.3194V6.40366H11.6806V7.76562ZM10.3897 7.6953H11.6103V6.47398H10.3897V7.6953Z" />
      <path d="M11.6462 8.92367H10.3546V16.2116H11.6462V8.92367Z" />
      <path d="M11.6806 16.2467H10.3194V8.89062H11.6806V16.2467ZM10.3897 16.1764H11.6103V8.96094H10.3897V16.1764Z" />
      <path d="M11 2C9.21997 2 7.47991 2.52784 5.99987 3.51677C4.51983 4.50571 3.36628 5.91131 2.68509 7.55585C2.0039 9.20038 1.82567 11.01 2.17294 12.7558C2.5202 14.5016 3.37737 16.1053 4.63604 17.364C5.89472 18.6226 7.49836 19.4798 9.24419 19.8271C10.99 20.1743 12.7996 19.9961 14.4442 19.3149C16.0887 18.6337 17.4943 17.4802 18.4832 16.0001C19.4722 14.5201 20 12.78 20 11C19.9968 8.61402 19.0476 6.32667 17.3605 4.63953C15.6733 2.95239 13.386 2.00316 11 2ZM11 18.9453C9.42857 18.9453 7.89242 18.4793 6.58582 17.6063C5.27922 16.7332 4.26085 15.4924 3.65949 14.0405C3.05813 12.5887 2.90079 10.9912 3.20736 9.44994C3.51393 7.9087 4.27065 6.49299 5.38182 5.38181C6.49299 4.27064 7.90871 3.51393 9.44995 3.20735C10.9912 2.90078 12.5887 3.05813 14.0405 3.65949C15.4924 4.26085 16.7332 5.27922 17.6063 6.58582C18.4793 7.89242 18.9453 9.42856 18.9453 11C18.9425 13.1064 18.1045 15.1257 16.6151 16.6151C15.1257 18.1045 13.1064 18.9425 11 18.9453Z" />
    </SvgIcon>
  )
}

export function InfoLxIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <rect x="118.82" y="63.13" width="18.37" height="18.37" />
      <path d="M137.68,82H118.32V62.63h19.36Zm-18.36-1h17.36V63.63H119.32Z" />
      <rect x="118.82" y="98.47" width="18.37" height="103.65" />
      <path d="M137.68,202.62H118.32V98h19.36Zm-18.36-1h17.36V99H119.32Z" />
      <path d="M128,0A128,128,0,1,0,256,128,128.17,128.17,0,0,0,128,0Zm0,241A113,113,0,1,1,241,128,113.15,113.15,0,0,1,128,241Z" />
    </SvgIcon>
  )
}

export function InfoLxFillIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 32 32"
      fill="none"
      sx={{ ...((props.sx as object) ?? {}), opacity: 1 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 16C29 23.1796 23.1796 29 16 29C8.82029 29 3 23.1796 3 16C3 8.82029 8.82029 3 16 3C23.1796 3 29 8.82029 29 16ZM16 23.475C16.5385 23.475 16.975 23.0385 16.975 22.5V14.7C16.975 14.1615 16.5385 13.725 16 13.725C15.4615 13.725 15.025 14.1615 15.025 14.7V22.5C15.025 23.0385 15.4615 23.475 16 23.475ZM16 9.5C16.718 9.5 17.3 10.082 17.3 10.8C17.3 11.518 16.718 12.1 16 12.1C15.282 12.1 14.7 11.518 14.7 10.8C14.7 10.082 15.282 9.5 16 9.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function ListIcon(): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 256 256">
      <rect
        x="134.43"
        y="-49.67"
        width="15"
        height="228.14"
        transform="translate(206.33 -77.53) rotate(90)"
      />
      <rect
        x="134.43"
        y="15.15"
        width="15"
        height="228.14"
        transform="translate(271.15 -12.71) rotate(90)"
      />
      <rect
        x="134.43"
        y="79.58"
        width="15"
        height="228.14"
        transform="translate(335.58 51.72) rotate(90)"
      />
      <rect y="56.85" width="15" height="15" />
      <rect y="121.72" width="15" height="15" />
      <rect y="186.15" width="15" height="15" />
    </SvgIcon>
  )
}

export function SaveIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M213.77,0H8V256H248V34.39ZM82.68,15h90.64V90.5H82.68ZM203.21,241H52.79V135.5H203.21Zm29.88,0H218.15V120.5H37.85V241H22.91V15H67.73v90.5H188.27V15h19.31l25.51,25.61Z" />
      <rect x="120.53" y="28.25" width="14.94" height="45.5" />
    </SvgIcon>
  )
}

export function PDFIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 26 26" fill="none">
      <path d="M5.59647 2.06934V23.931H18.4795L24 18.4662V2.06934H5.59647Z" fill="#EEEDED" />
      <path d="M18.4795 18.4243L18.4795 23.931L24 18.4243H18.4795Z" fill="#999999" />
      <path d="M20.803 6.22527H8.79431V7.16261H20.803V6.22527Z" fill="#B7B6B6" />
      <path d="M20.803 8.5733H8.79431V9.51063H20.803V8.5733Z" fill="#B7B6B6" />
      <path d="M20.803 10.9213H8.79431V11.8587H20.803V10.9213Z" fill="#B7B6B6" />
      <path d="M20.803 13.2694H8.79431V14.2067H20.803V13.2694Z" fill="#B7B6B6" />
      <path d="M2 6.79451V19.2067H14.5388V6.79451H2Z" fill="#D31900" />
      <path
        d="M13.2356 14.092C13.0731 13.783 12.6796 13.6332 12.0319 13.6332C11.5782 13.641 11.1261 13.6871 10.6803 13.771C9.94355 13.0006 9.18171 11.8955 8.63865 10.8015C8.70091 10.5447 8.75279 10.3136 8.79603 10.097C8.86562 9.77029 8.91614 9.43989 8.94736 9.10744C8.97676 8.76504 8.97763 8.40466 8.78825 8.09136C8.74501 8.01945 8.51585 7.66335 8.24605 7.66335C8.10332 7.67175 7.96188 7.69499 7.82406 7.73269C7.55685 7.81829 7.43233 8.034 7.34585 8.23174C7.05357 8.90029 7.45568 10.0396 7.85346 10.8811C7.46773 12.3339 6.95681 13.7512 6.32632 15.1175C4.78534 15.8091 3.96643 16.4922 3.89119 17.1471C3.86352 17.3893 3.92146 17.7463 4.35556 18.0647C4.47445 18.1519 4.61841 18.199 4.76632 18.1991C5.13211 18.1991 5.49876 17.9295 5.91902 17.3508C6.28914 16.8194 6.61203 16.2571 6.88408 15.6705C8.02772 15.1895 9.21485 14.8169 10.4295 14.5577C11.0712 15.1569 11.6488 15.4616 12.1478 15.4616C12.3306 15.4633 12.5111 15.4202 12.6731 15.3363C12.8351 15.2524 12.9737 15.1302 13.0765 14.9805C13.3178 14.6484 13.3714 14.3488 13.2356 14.092ZM7.89583 8.98417C7.91305 8.79027 7.98463 8.60497 8.10251 8.44917C8.18293 8.53477 8.42679 8.94993 8.13018 9.63132C8.04702 9.54605 7.98313 9.44425 7.94273 9.33268C7.90233 9.22112 7.88634 9.10232 7.89583 8.98417ZM9.84064 13.949C8.98438 14.1496 8.1421 14.4046 7.31905 14.7126C7.71683 13.7756 8.06324 12.8181 8.35674 11.8441C8.78395 12.5879 9.28076 13.2903 9.84064 13.9422V13.949ZM12.5499 14.4275C12.5286 14.4746 12.5019 14.5192 12.4703 14.5602C12.3916 14.6681 12.2351 14.722 12.0042 14.722C11.8538 14.722 11.7768 14.6595 11.6065 14.5209C11.5615 14.4849 11.5131 14.4447 11.4551 14.4002C11.6731 14.377 11.8922 14.3656 12.1115 14.3659C12.4115 14.3625 12.5015 14.3984 12.5499 14.4241V14.4275ZM4.78015 17.4647C4.61845 17.3397 4.62796 17.2592 4.63142 17.2284C4.65304 17.035 4.96521 16.6703 5.76683 16.2158C5.18658 17.2395 4.86144 17.4321 4.78015 17.4647Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function DefendantIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M215.26,159c-7.47-27.78-34.28-49.24-61.07-57.6a53.39,53.39,0,1,0-50.32-.57c-26.49,7.88-53,29.44-60.17,58.17H1.37v97.43H256V159ZM89.76,54.06a39.8,39.8,0,1,1,39.8,39.79A39.84,39.84,0,0,1,89.76,54.06ZM78.58,129.48c14.19-11.85,32.18-18.65,49.35-18.65,34.68,0,63.75,23.71,72.83,48.18H57.83C61.28,148.19,68.35,138,78.58,129.48ZM242.24,242.65H15.17V172.81H242.24Z" />
    </SvgIcon>
  )
}

export function NumberOneIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="126.21 185.41 126.21 102.86 112.87 102.86 112.87 94.03 144.92 70.59 144.92 185.41 126.21 185.41" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberTwoIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M95.54,107.91c0-17.54,14.49-31.57,32.83-31.57s33.86,13.59,33.86,32c0,7-4.73,14.32-12.86,25l-23.22,30.24h36.08v16.08H93.77l45.1-58.6c3.7-4.83,5.62-8.92,5.62-12.72,0-8.76-6.21-15.34-15.68-15.34-8.87,0-16.12,6.43-16.12,14.91Z" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberThreeIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M131.92,113.6c18,.73,30,15.49,30,32.15,0,19.3-14.94,33.91-34.61,33.91-15.23,0-28.39-9.35-33.27-22.65H115.5c2.52,3.65,6.81,5.84,12.13,5.84,10.2,0,16.41-9.2,16.41-17.1,0-9.5-6.5-17.24-15.82-17.24a15.21,15.21,0,0,0-12.12,6.28H96.75L129,92.42H94.53V76.34h65.95Z" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberFourIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M129.69,136v-27l-21.14,27Zm29.88,0V152H146.85v19H129.69V152H74.07l72.75-85.49V136Z" />
      <path d="M128,256.68a128,128,0,1,1,128-128A128.17,128.17,0,0,1,128,256.68Zm0-241a113,113,0,1,0,113,113A113.15,113.15,0,0,0,128,15.64Z" />
    </SvgIcon>
  )
}

export function NumberFiveIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M120.24,92.42l-4.44,24.11c2.81-2.2,9.76-4.68,16.41-4.68,17.16,0,29.28,13.88,29.28,33,0,19.73-15.23,34.78-34.3,34.78-16.86,0-29.43-12.28-32.68-24H114c3,4.39,8.42,6.87,14.19,6.87,8.43,0,16.56-6.72,16.56-17.68,0-9.8-6.35-16.37-15.67-16.37a21.34,21.34,0,0,0-16,7.16l-16.42-4.38,9.47-54.95h46.73l4,16.08Z" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberSixIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M111.44,145.9c0,9.36,7.1,17.1,16.56,17.1s16.56-7.74,16.56-17.1a16.56,16.56,0,1,0-33.12,0Zm10-32c1.33-.88,5.33-2.05,9.47-2.05,16.26,0,31.35,15.49,31.35,34.05S146.93,179.66,128,179.66c-21.89-.29-34.31-16.51-34.31-33.76,0-6.28,1.78-14,5.92-22.07L124,76.34h17.15Z" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberSevenIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <polygon points="100.94 178.78 139.98 93.29 90.14 93.29 90.14 77.22 165.86 77.22 120.61 178.78 100.94 178.78" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberEightIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M116.22,103.81a11.52,11.52,0,0,0,11.68,11.84,11.68,11.68,0,0,0,12-11.84c0-6.72-5-11.69-12-11.69A11.32,11.32,0,0,0,116.22,103.81Zm-4.73,43.41c0,9.5,7.09,16.66,16.41,16.66,9.61,0,16.86-7.16,16.86-16.66S137.51,131,127.9,131C118.61,131,111.49,137.86,111.49,147.22Zm45.4-43.41a27.19,27.19,0,0,1-8.43,18.42,31,31,0,0,1,13,25,32.8,32.8,0,0,1-9.75,23.57A33.59,33.59,0,0,1,94.5,147.22c0-9.65,5.18-19,13-25-4.73-4.83-8.14-11.69-8.14-18.42,0-15.49,13-28.34,28.55-28.34S156.74,88.33,156.89,103.81Z" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function NumberNineIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M111.44,110.1a16.56,16.56,0,1,0,33.12,0c0-9.36-7.1-17.1-16.56-17.1S111.44,100.74,111.44,110.1Zm23.07,32c-1.33.88-5.33,2.05-9.47,2.05-16.26,0-31.35-15.49-31.35-34.05S109.07,76.34,128,76.34c21.89.29,34.31,16.51,34.31,33.76a47.43,47.43,0,0,1-5.92,22.06l-25.14,47.5H113.36Z" />
      <path d="M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z" />
    </SvgIcon>
  )
}

export function LfCoinIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M128,254.7A126.7,126.7,0,1,1,254.7,128,126.85,126.85,0,0,1,128,254.7Zm0-237.78A111.08,111.08,0,1,0,239.08,128,111.21,111.21,0,0,0,128,16.92Z" />
      <path d="M133.25,196.26c-26.63,0-44.86-11.21-54.21-33.32a91.56,91.56,0,0,1-4.69-15.46l-.22-1H60.59L63,134.93h9.41l-.07-1.37c-.13-2.2-.19-4.53-.19-6.93,0-.82,0-1.66,0-2.51l0-1.35H60.59L63,111.27H73.32l.22-1C77.31,91.47,86.88,77.79,102,69.57a65,65,0,0,1,30.83-7.8h.6c10.89,0,20.18,2.39,27.62,7.09l-3.46,16.08a38,38,0,0,0-24.34-8.83h-.18c-9.94,0-18.41,2.44-25.19,7.25a41.44,41.44,0,0,0-11,12.15,40.08,40.08,0,0,0-5.71,14.17l-.31,1.55h60.76l-2.32,11.5H89.57l0,1.25c0,.87,0,1.71,0,2.52,0,3.54,0,5.8,0,7.12l0,1.27h57.17l-2.37,11.51h-53l.32,1.56c2.63,12.9,8.62,22.23,17.81,27.73a42.59,42.59,0,0,0,22.1,6.17h.16c10.87,0,19.56-2.85,25.84-8.46v17.78a57.41,57.41,0,0,1-23.69,5.08Z" />
    </SvgIcon>
  )
}

export function LfClockIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M128.25,251a123,123,0,1,1,123-123A123.12,123.12,0,0,1,128.25,251Zm0-231a108,108,0,1,0,108,108A108.1,108.1,0,0,0,128.25,20Z" />
      <polygon points="159.1 173.69 116.57 137.8 116.57 69.53 131.57 69.53 131.57 130.83 168.77 162.22 159.1 173.69" />
      <rect
        x="217"
        y="-6.9"
        width="15"
        height="69.12"
        transform="translate(62.23 185.25) rotate(-51.19)"
      />
      <rect
        x="-3.06"
        y="19.77"
        width="69.12"
        height="15"
        transform="translate(-10.14 25.77) rotate(-38.82)"
      />
    </SvgIcon>
  )
}

export function CalendarIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} x="0px" y="0px" viewBox="0 0 256 256">
      <path d="M0,0V256H256V0ZM241,241H15V60.5H30.5v15h15v-15h30v15h15v-15h30v15h15v-15h30v15h15v-15h30v15h15v-15H241Zm0-195.5H225.5v-15h-15v15h-30v-15h-15v15h-30v-15h-15v15h-30v-15h-15v15h-30v-15h-15v15H15V15H241Z" />
      <rect x="45.5" y="135.5" width="30" height="15" />
      <rect x="45.5" y="195.5" width="30" height="15" />
      <rect x="180.5" y="105.5" width="30" height="15" />
      <rect x="180.5" y="135.5" width="30" height="15" />
      <rect x="45.5" y="165.5" width="30" height="15" />
      <rect x="180.5" y="165.5" width="30" height="15" />
      <rect x="180.5" y="195.5" width="30" height="15" />
      <rect x="135.5" y="105.5" width="30" height="15" />
      <rect x="135.5" y="135.5" width="30" height="15" />
      <rect x="135.5" y="165.5" width="30" height="15" />
      <rect x="135.5" y="195.5" width="30" height="15" />
      <rect x="90.5" y="105.5" width="30" height="15" />
      <rect x="90.5" y="135.5" width="30" height="15" />
      <rect x="90.5" y="165.5" width="30" height="15" />
      <rect x="90.5" y="195.5" width="30" height="15" />
    </SvgIcon>
  )
}

export function LegalDocumentIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 256 256">
      <path d="M117.94,91.88a15.58,15.58,0,0,0-8,8H57.79v12.57H72.56L53.84,159.24v1.21a28,28,0,1,0,56,0v-1.21L91.11,112.45h18.83a15.69,15.69,0,0,0,8,8v89.22H91.9v12.56h64.63v-12.6h-26v-89.2a15.69,15.69,0,0,0,8-8h18.83L138.6,159.24v1.21a28,28,0,1,0,56,0v-1.21l-18.7-46.79h14.73V99.88H138.51A15.61,15.61,0,0,0,117.94,91.88Zm-36.12,84a15.6,15.6,0,0,1-14.1-9.16H95.93A15.6,15.6,0,0,1,81.82,175.92Zm12.43-21.77H69.38l12.44-31.1Zm72.36,21.77a15.59,15.59,0,0,1-14.1-9.16h28.2A15.59,15.59,0,0,1,166.61,175.92Zm12.45-21.77H154.14l12.45-31.1Z" />
      <rect x="59.87" y="55.51" width="64.18" height="15" />
      <rect x="59.87" y="28.01" width="64.18" height="15" />
      <path d="M168.68-.73H24.07V254.83H230.35V60.94Zm4.37,25.44,31.87,31.86H173.05Zm42.4,215.22H39.75V14.17h118.4v57.3h57.3Z" />
    </SvgIcon>
  )
}

export function InboxLxcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} x="0px" y="0px" viewBox="0 0 256 256">
      <g>
        <polygon points="91.3,90.3 101.9,79.7 120.5,98.1 120.5,0 135.5,0 135.5,98.1 154.1,79.7 164.7,90.3 128,126.6 	" />
        <path
          d="M164.7,0.1v15H241v131h-60.6h-15c-0.3,5.4-1.8,10.5-4.2,15c-6.3,11.9-18.8,20.1-33.1,20.1
		c-14.4,0-26.9-8.1-33.1-20.1c-2.4-4.5-3.9-9.6-4.2-15h-15H15v-131h76.3v-15H0v256h256V0.1H164.7z M241,241.1H15v-80h63.6
		c7.2,20.4,26.6,35,49.5,35s42.3-14.7,49.5-35H241V241.1z"
        />
      </g>
    </SvgIcon>
  )
}

export function InboxLxcon2(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M13.5796 3.87002H13.1194L11.0675 1.81818H2.9624V16.13H5.48087V18.1818H17.0377V7.32812L13.5796 3.87002ZM13.8289 5.32102L15.5867 7.07883H13.8289V5.32102ZM11.9177 3.87002H11.3104V3.26278L11.9177 3.87002ZM3.85729 15.2798V2.66832H10.4667V3.87002H5.48087V15.2798H3.85729ZM16.1875 17.3381H6.37576V4.72017H12.9851V7.92258H16.1875V17.3381Z" />
      <path d="M14.3083 9.93607H8.25507V10.7798H14.3083V9.93607Z" />
      <path d="M14.3083 11.6619H8.25507V12.5057H14.3083V11.6619Z" />
      <path d="M14.2827 13.4773H8.22947V14.321H14.2827V13.4773Z" />
    </SvgIcon>
  )
}

export function WordDocIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
      <path d="M6.69076 2.01465V29.9851H23.0071L30 22.9933V2.01465H6.69076Z" fill="#EEEDED" />
      <path d="M23.0071 22.9396L23.0071 29.9851L30 22.9396H23.0071Z" fill="#999999" />
      <path d="M25.9499 7.33187H10.7408V8.53112H25.9499V7.33187Z" fill="#B7B6B6" />
      <path d="M25.9499 10.336H10.7408V11.5353H25.9499V10.336Z" fill="#B7B6B6" />
      <path d="M25.9499 13.3402H10.7408V14.5394H25.9499V13.3402Z" fill="#B7B6B6" />
      <path d="M25.9499 16.3443H10.7408V17.5435H25.9499V16.3443Z" fill="#B7B6B6" />
      <path d="M2 8.06017V23.9406H17.8805V8.06017H2Z" fill="#185ABB" />
      <path
        d="M6.44434 10.6668L7.62387 18.5522H7.65783L8.91183 10.6668H10.9708L12.2259 18.5522H12.2577L13.4383 10.6668H15.4995L13.5577 21.3341H11.1482L9.95776 13.591H9.9249L8.73003 21.3341H6.32058L4.38207 10.6668H6.44434Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function JPGDocIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 27 27" fill="none">
      <path d="M27 0H0V27H27V0Z" fill="white" />
      <path d="M23.3035 3.45807H3.69757V23.064H23.3035V3.45807Z" fill="#999999" />
      <path
        d="M5.55114 18.2982L11.3322 10.0393L14.5921 14.802L16.7011 12.5171L21.4499 18.2982H5.55114Z"
        fill="white"
      />
      <path
        d="M17.7979 11.1976C18.6191 11.1976 19.2848 10.5319 19.2848 9.71077C19.2848 8.8896 18.6191 8.2239 17.7979 8.2239C16.9768 8.2239 16.3111 8.8896 16.3111 9.71077C16.3111 10.5319 16.9768 11.1976 17.7979 11.1976Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function PPTDocIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 27 27" fill="none">
      <path d="M4.51443 0V26.982H20.2542L27 20.2363V0H4.51443Z" fill="#EEEDED" />
      <path d="M20.2542 20.1845L20.2542 26.982L27 20.1845H20.2542Z" fill="#999999" />
      <path d="M23.1068 13.8328H8.1974V15.0076H23.1068V13.8328Z" fill="#B7B6B6" />
      <path d="M23.1068 16.5861H8.1974V17.7609H23.1068V16.5861Z" fill="#B7B6B6" />
      <path
        d="M15.3351 1.851C14.3061 1.85079 13.3001 2.15577 12.4444 2.72737C11.5887 3.29896 10.9218 4.11149 10.5279 5.06218C10.1341 6.01286 10.0311 7.059 10.2318 8.06825C10.4326 9.07751 10.9282 10.0046 11.6559 10.7321C12.3836 11.4597 13.3108 11.9551 14.3201 12.1557C15.3294 12.3562 16.3755 12.253 17.3261 11.8589C18.2767 11.4649 19.0891 10.7978 19.6605 9.94199C20.2319 9.08619 20.5367 8.08015 20.5363 7.05111H15.3351V1.851Z"
        fill="#B7B6B6"
      />
      <path
        d="M15.968 1.1854V6.38762H21.1702C21.1702 5.70445 21.0356 5.02798 20.7742 4.39682C20.5128 3.76565 20.1296 3.19216 19.6465 2.70909C19.1634 2.22602 18.5899 1.84283 17.9588 1.58139C17.3276 1.31996 16.6511 1.1854 15.968 1.1854Z"
        fill="#CCCCCC"
      />
      <path d="M0 5.83613V21.1554H15.3193V5.83613H0Z" fill="#D0614A" />
      <path
        d="M8.06324 8.35061C8.52218 8.33621 8.97832 8.42729 9.39654 8.61685C9.73733 8.77933 10.0357 9.01876 10.2682 9.31626C10.4915 9.60978 10.6532 9.94542 10.7436 10.303C10.8397 10.6725 10.8884 11.0528 10.8883 11.4345C10.8982 11.9068 10.8175 12.3766 10.6506 12.8186C10.5085 13.1881 10.2811 13.519 9.98713 13.7842C9.68775 14.0428 9.33653 14.2345 8.95704 14.3463C8.52203 14.4754 8.07008 14.5384 7.61633 14.5333H6.50701V18.6409H4.43098V8.35061H8.06324ZM7.42933 13.0056C7.6128 13.0133 7.79597 12.9843 7.968 12.92C8.14003 12.8558 8.29743 12.7577 8.4309 12.6316C8.68516 12.3815 8.8123 11.9941 8.8123 11.4694C8.8123 10.9496 8.70665 10.5566 8.48161 10.2872C8.25658 10.0178 7.88997 9.8836 7.37123 9.8836H6.50701V13.0108L7.42933 13.0056Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function XLSDocIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
      <path d="M6.70442 2.02295V29.977H23.0112L30 22.9893V2.02295H6.70442Z" fill="#EEEDED" />
      <path d="M23.0112 22.9356L23.0112 29.977L30 22.9356H23.0112Z" fill="#999999" />
      <path d="M20.9961 7.21664H10.647V8.4316H20.9961V7.21664Z" fill="#B7B6B6" />
      <path d="M20.9961 10.2606H10.647V11.4756H20.9961V10.2606Z" fill="#B7B6B6" />
      <path d="M20.9961 13.3046H10.647V14.5195H20.9961V13.3046Z" fill="#B7B6B6" />
      <path d="M20.9961 16.3486H10.647V17.5635H20.9961V16.3486Z" fill="#B7B6B6" />
      <path d="M26.0574 7.21664H21.8159V8.4316H26.0574V7.21664Z" fill="#B7B6B6" />
      <path d="M26.0574 10.2606H21.8159V11.4756H26.0574V10.2606Z" fill="#B7B6B6" />
      <path d="M26.0574 13.3046H21.8159V14.5195H26.0574V13.3046Z" fill="#B7B6B6" />
      <path d="M26.0574 16.3486H21.8159V17.5635H26.0574V16.3486Z" fill="#B7B6B6" />
      <path d="M2 8.06492V23.9361H17.8711V8.06492H2Z" fill="#048146" />
      <path
        d="M8.59912 10.67L9.97279 14.119L11.3322 10.67H13.6757L11.1943 15.9403L13.8519 21.331H11.4362L9.90384 17.719L8.3813 21.331H6.01595L8.67683 15.9403L6.22501 10.67H8.59912Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function HTMLDocIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 27 27" fill="none">
      <path d="M4.48922 0V27H20.2395L26.9887 20.2508V0H4.48922Z" fill="#EEEDED" />
      <path d="M20.2395 20.199L20.2395 27L26.9887 20.199H20.2395Z" fill="#999999" />
      <path d="M-0.00390625 16.3444V24.0546H17.9834V16.3444H-0.00390625Z" fill="#D0614A" />
      <path
        d="M2.9288 17.8668V19.5985H3.99446V17.8668H4.90789V22.3959H3.99446V20.3872H2.9288V22.3959H2.01537V17.8668H2.9288Z"
        fill="white"
      />
      <path
        d="M8.32055 18.6153H7.331V22.3959H6.41758V18.6153H5.42803V17.8668H8.32055V18.6153Z"
        fill="white"
      />
      <path
        d="M10.2172 17.8668L10.8642 21.0638H10.8769L11.5302 17.8668H12.8813V22.3959H12.0482V18.7802H12.0356L11.23 22.3959H10.5153L9.7097 18.7802H9.69701V22.3959H8.85971V17.8668H10.2172Z"
        fill="white"
      />
      <path d="M13.6615 17.8668H14.575V21.6474H16.1925V22.3959H13.6615V17.8668Z" fill="white" />
      <path
        d="M13.5209 7.43962V8.61946L10.3049 9.923L13.5209 11.2265V12.3778L8.70746 10.4273V9.41871L13.5209 7.43962Z"
        fill="#B7B6B6"
      />
      <path d="M17.3459 5.40342L15.1956 12.4349H14.1627L16.2771 5.40342H17.3459Z" fill="#B7B6B6" />
      <path
        d="M21.1709 9.923L17.9549 8.61946V7.43962L22.7694 9.41871V10.4273L17.9549 12.3778V11.2265L21.1709 9.923Z"
        fill="#B7B6B6"
      />
    </SvgIcon>
  )
}

export function ZIPDocIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 27 27" fill="none">
      <path d="M4.48922 0V27H20.2395L26.9887 20.2508V0H4.48922Z" fill="#EEEDED" />
      <path d="M20.2395 20.199L20.2395 27L26.9887 20.199H20.2395Z" fill="#999999" />
      <path d="M-0.00390625 16.3444V24.0546H15.74V16.3444H-0.00390625Z" fill="#D31900" />
      <path
        d="M15.333 1.55412V2.35231H13.9121V3.23508H15.333V4.03327H13.9121V4.91498H15.333V5.71317H13.9121V6.597H15.333V7.1256C15.2341 7.19475 15.1553 7.28887 15.1046 7.39836H13.9121V8.28324H15.075C15.075 8.34879 15.0835 8.41328 15.0877 8.47988C14.6511 8.80762 14.2737 9.43137 14.1288 10.1429C13.8888 11.3121 13.7694 11.8968 13.5315 13.0639C13.3201 14.1211 14.3054 14.9775 15.7442 14.9775C17.1831 14.9775 18.1684 14.1233 17.9527 13.0639C17.7149 11.901 17.5954 11.3121 17.3575 10.1429C17.2116 9.42926 16.8353 8.80868 16.3976 8.47988C16.4124 8.25576 16.4251 8.057 16.4441 7.76204C16.4513 7.65404 16.4347 7.54577 16.3955 7.44488H17.514V6.55577H16.0889V5.75758H17.5108V4.87481H16.0889V4.07662H17.5108V3.19491H16.0889V2.39989H17.5108V1.51395H16.0889V0.784477H13.9121V1.55412H15.333ZM16.5181 11.7625C16.5562 12.2319 16.5741 12.4645 16.6122 12.9318C16.6482 13.3547 16.257 13.6972 15.7411 13.6972C15.2251 13.6972 14.8329 13.3557 14.8678 12.9318C14.9048 12.4645 14.9249 12.2319 14.9619 11.7625C14.9619 11.5561 15.0439 11.3582 15.1898 11.2123C15.3357 11.0664 15.5336 10.9844 15.74 10.9844C15.9464 10.9844 16.1443 11.0664 16.2902 11.2123C16.4361 11.3582 16.5181 11.5561 16.5181 11.7625ZM15.7411 9.69461C15.8474 9.68717 15.9498 9.65164 16.0378 9.59164C16.1258 9.53164 16.1964 9.44933 16.2422 9.35314C16.2506 9.45886 16.2591 9.56458 16.2718 9.71047C16.2929 9.96843 16.0603 10.1756 15.7432 10.1756C15.426 10.1756 15.1903 9.9642 15.2146 9.71047C15.2262 9.56669 15.2347 9.45991 15.2431 9.35208C15.289 9.4477 15.3591 9.52965 15.4464 9.58975C15.5338 9.64985 15.6354 9.686 15.7411 9.69461Z"
        fill="#B7B6B6"
      />
      <path
        d="M4.88779 18.3447H3.07468V17.4714H6.11626V18.2781L4.14034 21.8821H6.14904V22.7553H2.94147V21.9783L4.88779 18.3447Z"
        fill="white"
      />
      <path d="M6.89332 17.4714H7.95899V22.7575H6.89332V17.4714Z" fill="white" />
      <path
        d="M10.7627 17.4714C10.9986 17.4638 11.2331 17.5108 11.4478 17.6089C11.6228 17.6918 11.776 17.8145 11.895 17.9673C12.0103 18.118 12.0938 18.2907 12.1402 18.4747C12.1892 18.6643 12.2141 18.8593 12.2142 19.0551C12.2193 19.2976 12.1776 19.5388 12.0916 19.7656C12.0192 19.9556 11.9025 20.1256 11.7512 20.2614C11.5979 20.3947 11.4176 20.4931 11.2226 20.55C10.9989 20.6165 10.7666 20.6489 10.5333 20.6462H9.96451V22.7554H8.89884V17.4693L10.7627 17.4714ZM10.4371 19.8618C10.5314 19.8658 10.6256 19.8509 10.714 19.8178C10.8025 19.7848 10.8834 19.7343 10.9519 19.6694C11.083 19.5411 11.1486 19.3413 11.1486 19.0699C11.1636 18.8539 11.1031 18.6394 10.9773 18.4631C10.8642 18.3257 10.6739 18.2517 10.4085 18.2517H9.96451V19.8576L10.4371 19.8618Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function ArrowIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="22" height="23" viewBox="0 0 22 23" fill="none">
      <path
        d="M10.4678 2.5V18.4785L8.55247 16.5625L7.80786 17.3078L11 20.5L14.1922 17.3078L13.4476 16.5625L11.5323 18.4785V2.5H10.4678Z"
        fill="#717171"
      />
    </SvgIcon>
  )
}

export function CollapseIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M1.81818 5.32677L6.49715 9.99935L1.81818 14.6719V16.0277L7.84588 10.0064L7.83948 9.99935L7.84588 9.9936L1.81818 3.9723V5.32677Z" />
      <path d="M18.1818 14.7359L13.4389 9.99935L18.1818 5.26285V3.90837L12.0902 9.9936L12.0966 9.99935L12.0902 10.0064L18.1818 16.0916V14.7359Z" />
    </SvgIcon>
  )
}

export function ExpandIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M8.63047 16.1399L3.48359 11L8.63047 5.86018V4.36955L2 10.993L2.00703 11L2 11.0071L8.63047 17.6305V16.1399Z" />
      <path d="M13.2992 5.78987L18.5164 11L13.2992 16.2102V17.7008L20 11.0071L19.993 11L20 10.993L13.2992 4.29924V5.78987Z" />
    </SvgIcon>
  )
}

export function InfoFullIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M11 2C6.03594 2 2 6.03594 2 11C2 15.9641 6.03594 20 11 20C15.9641 20 20 15.9641 20 11C20 6.03594 15.9641 2 11 2ZM11.9352 16.1539H10.5008V8.22266H11.9352V16.1539ZM11.225 6.76016C10.7469 6.76016 10.3672 6.36641 10.3672 5.91641C10.3672 5.45234 10.7469 5.04453 11.225 5.04453C11.675 5.04453 12.0687 5.45234 12.0687 5.91641C12.0687 6.36641 11.675 6.76016 11.225 6.76016Z" />
    </SvgIcon>
  )
}

export function SeparatorIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} width="2" height="18" viewBox="0 0 2 18" fill="none">
      <path d="M1 0V18" stroke={props.htmlColor} />
    </SvgIcon>
  )
}

export function UploadIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 26 26" fill="none">
      <path d="M24 18.9196V3.43604H2V18.9196H9.79131V17.6206H3.31276V4.73502H22.6881V17.6206H16.2087V18.9196H24Z" />
      <path d="M15.2457 12.3334L16.1613 11.4272L13 8.29601L9.83869 11.4272L10.7535 12.3334L12.3522 10.751V22.5641H13.6478V10.751L15.2457 12.3334Z" />
    </SvgIcon>
  )
}

export function ClockIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22" fill="none">
      <path d="M11.0181 19.8241C9.30921 19.8241 7.63874 19.3173 6.21789 18.368C4.79703 17.4186 3.68961 16.0692 3.03567 14.4904C2.38172 12.9116 2.21062 11.1744 2.544 9.4984C2.87738 7.82239 3.70026 6.28288 4.9086 5.07454C6.11694 3.8662 7.65645 3.04332 9.33246 2.70994C11.0085 2.37656 12.7457 2.54766 14.3245 3.20161C15.9032 3.85555 17.2526 4.96298 18.202 6.38383C19.1514 7.80468 19.6581 9.47515 19.6581 11.184C19.6559 13.4748 18.7449 15.6711 17.125 17.291C15.5052 18.9108 13.3089 19.8218 11.0181 19.8241ZM11.0181 3.59759C9.51761 3.59759 8.05085 4.04252 6.80327 4.87613C5.55569 5.70973 4.58333 6.89457 4.00913 8.28081C3.43493 9.66704 3.2847 11.1924 3.57742 12.664C3.87014 14.1357 4.59268 15.4874 5.65366 16.5484C6.71463 17.6094 8.0664 18.3319 9.53802 18.6246C11.0096 18.9174 12.535 18.7671 13.9212 18.1929C15.3075 17.6187 16.4923 16.6464 17.3259 15.3988C18.1595 14.1512 18.6045 12.6844 18.6045 11.184C18.6026 9.17253 17.8027 7.24398 16.3804 5.82165C14.9581 4.39933 13.0295 3.59945 11.0181 3.59759Z" />
      <path d="M13.1851 14.3935L10.1976 11.8724V7.0768H11.2513V11.3828L13.8644 13.5878L13.1851 14.3935Z" />
      <path d="M16.2166 2.20285L15.5562 3.02389L19.3396 6.06691L20 5.24586L16.2166 2.20285Z" />
      <path d="M5.78286 2.17596L2 5.21964L2.66052 6.04057L6.44338 2.9969L5.78286 2.17596Z" />
    </SvgIcon>
  )
}

export function ConfigurationIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 26 26" fill="none">
      <path d="M20.9937 15.4833L21.0154 15.4137L24 14.8246V11.1754L21.018 10.588L20.9963 10.5185C20.844 10.0298 20.6474 9.55603 20.4089 9.10308L20.375 9.03965L22.0363 6.5425L19.4575 3.96367L16.9621 5.62496L16.8987 5.59107C16.4458 5.35323 15.972 5.15749 15.4833 5.00632L15.4137 4.9846L14.8246 2H11.1754L10.588 4.98199L10.5185 5.00371C10.0297 5.15572 9.55589 5.35233 9.10308 5.59107L9.03965 5.62496L6.5425 3.96367L3.96367 6.5425L5.62496 9.03791L5.59107 9.10134C5.35353 9.55438 5.1578 10.0281 5.00632 10.5167L4.9846 10.5863L2 11.1754V14.8246L4.98199 15.412L5.00371 15.4815C5.15603 15.9702 5.35263 16.444 5.59107 16.8969L5.62496 16.9603L3.96367 19.4575L6.5425 22.0363L9.03791 20.375L9.10134 20.4089C9.55424 20.6468 10.028 20.8425 10.5167 20.9937L10.5863 21.0154L11.1754 24H14.8246L15.412 21.018L15.4815 20.9963C15.9703 20.8443 16.4441 20.6477 16.8969 20.4089L16.9603 20.375L19.4575 22.0363L22.0381 19.4558L20.375 16.9621L20.4089 16.8987C20.6468 16.4458 20.8425 15.972 20.9937 15.4833ZM20.3498 19.2907L19.2907 20.3524L17.0055 18.8284H16.9994C15.8412 19.5305 15.478 19.66 14.2946 19.9519H14.2877L13.749 22.6845H12.251L11.7123 19.9519H11.7054C10.3934 19.6313 10.0458 19.4645 9.00316 18.8319H8.99708L6.70932 20.3524L5.64755 19.2907L7.17156 17.0055V16.9994C6.46603 15.8421 6.33744 15.4789 6.04897 14.2946V14.2877L3.31635 13.749V12.251L6.04897 11.7123V11.7054C6.33223 10.5402 6.47038 10.1509 7.16809 9.00316V8.99708L5.64755 6.70932L6.70932 5.64842L8.99447 7.17156H9.00055C10.1588 6.46603 10.522 6.33657 11.7054 6.04897H11.7123L12.251 3.31635H13.749L14.2877 6.04897H14.2946C15.6066 6.36872 15.9542 6.53554 16.9968 7.16809H17.0029L19.2881 5.64494L20.3524 6.70932L18.8284 8.99447V9.00055C19.5305 10.1588 19.6591 10.522 19.9519 11.7054V11.7123L22.6845 12.251V13.749L19.9519 14.2877V14.2946C19.6304 15.6066 19.4645 15.9542 18.8319 16.9968V17.0029L20.3498 19.2907Z" />
      <path d="M13 8.48183C12.1064 8.48183 11.2328 8.74682 10.4898 9.24328C9.7468 9.73974 9.1677 10.4454 8.82573 11.271C8.48376 12.0966 8.39428 13.005 8.56862 13.8815C8.74295 14.7579 9.17326 15.5629 9.80514 16.1948C10.437 16.8267 11.2421 17.257 12.1185 17.4314C12.995 17.6057 13.9034 17.5162 14.729 17.1742C15.5546 16.8323 16.2602 16.2532 16.7567 15.5102C17.2531 14.7671 17.5181 13.8936 17.5181 13C17.5168 11.8021 17.0403 10.6537 16.1933 9.8067C15.3462 8.95967 14.1978 8.48321 13 8.48183ZM13 16.2079C12.3655 16.2079 11.7453 16.0198 11.2178 15.6673C10.6902 15.3148 10.2791 14.8138 10.0363 14.2276C9.79346 13.6414 9.72993 12.9964 9.85371 12.3742C9.97748 11.7519 10.283 11.1803 10.7316 10.7317C11.1803 10.283 11.7519 9.97752 12.3741 9.85374C12.9964 9.72996 13.6414 9.79349 14.2276 10.0363C14.8137 10.2791 15.3147 10.6903 15.6672 11.2178C16.0197 11.7453 16.2079 12.3655 16.2079 13C16.206 13.8502 15.8675 14.6651 15.2663 15.2663C14.6651 15.8675 13.8502 16.2061 13 16.2079Z" />
    </SvgIcon>
  )
}

export function MailIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 33 32" fill="none">
      <path
        d="M2.66663 6.32031V25.6797H30.6666V6.32031H2.66663ZM27.6358 7.96094L16.6666 17.4044L5.69741
      7.96094H27.6358ZM4.30725 8.92891L12.2982 15.8086L4.30725 22.6872V8.92891ZM5.25225
      24.0391L13.5549 16.8903L16.6666 19.5689L19.7783 16.8903L28.081 24.0391H5.25225ZM29.026
      22.6872L21.0351 15.8086L29.026 8.92891V22.6872Z"
      />
    </SvgIcon>
  )
}

export function CallIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 33 32" fill="none">
      <path d="M22.9616 17.3717L19.0241 21.3092C15.9096 19.4525 13.3065 16.8494 11.4498 13.7349L15.3873 9.79739L7.80867 2.21875L4.63678 5.39065C3.73539 6.28794 3.13001 7.43946 2.90185 8.69069C2.6737 9.94192 2.83369 11.233 3.36036 12.3907C4.7894 15.4897 6.65578 18.3675 8.90243 20.9362C12.0941 24.5805 16.0335 27.4944 20.4525 29.4796C22.7352 30.511 25.498 29.9794 27.3268 28.1506L30.5326 24.9459L22.9616 17.3717ZM26.0679 26.8873C24.7619 28.1933 22.803 28.5783 21.1908 27.8531C12.0896 23.7395 7.35258 16.7657 4.98131 11.6371C4.60897 10.8124 4.49753 9.89355 4.66193 9.00372C4.82633 8.1139 5.25871 7.29555 5.90116 6.65831L7.80867 4.74752L12.8618 9.7963L9.23056 13.4287L9.55868 14.0171C11.702 17.8784 14.885 21.0613 18.7462 23.2047L19.3347 23.5328L22.9671 19.9004L28.0158 24.9503L26.0679 26.8873Z" />
      <path d="M26.395 13.4494L28.1734 13.6048C28.4191 10.775 27.5316 7.96334 25.7058 5.78745C23.88 3.61156 21.2652 2.24934 18.4357 2L18.2804 3.77845C20.6378 3.98749 22.8161 5.12308 24.3373 6.9361C25.8586 8.74913 26.5986 11.0915 26.395 13.4494Z" />
      <path d="M22.8381 13.1377L24.6165 13.293C24.7792 11.4069 24.1871 9.53317 22.9702 8.08292C21.7533 6.63267 20.0108 5.72425 18.1251 5.5569L17.9698 7.33535C19.3844 7.46015 20.6917 8.14132 21.6045 9.22925C22.5173 10.3172 22.9609 11.7229 22.8381 13.1377Z" />
    </SvgIcon>
  )
}

export function BillIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M13.9215 2H3.73535V20H18.2647V6.3432L13.9215 2ZM14.2288 3.79086L16.4732 6.03594H14.2288V3.79086ZM17.215 18.9509H4.83996V3.04906H13.1797V7.085H17.215V18.9509Z" />
      <path d="M11.2813 16.6313C10.8321 16.6335 10.3917 16.5067 10.0126 16.2659C9.63339 16.0251 9.33136 15.6804 9.1424 15.2729H10.8876L11.0226 14.5353H8.92654C8.9174 14.4362 8.90825 14.3286 8.90825 14.2295C8.90825 14.1303 8.9174 14.041 8.92654 13.9419H11.1484L11.289 13.2043H9.14802C9.34066 12.8001 9.64252 12.4578 10.0195 12.2161C10.3965 11.9744 10.8336 11.843 11.2813 11.8367C11.9704 11.8367 12.5329 12.1784 12.9547 12.646L13.6579 12.1159C13.1256 11.4409 12.2797 11 11.2813 11C9.85255 11 8.66568 11.9534 8.22482 13.2043H7.26224V13.9419H8.06239C8.05396 14.041 8.05396 14.1303 8.05396 14.2295C8.05396 14.3286 8.05396 14.4362 8.06239 14.5353H7.26224V15.2736H8.23114C8.67974 16.5603 9.94115 17.4687 11.2813 17.4687C12.3451 17.4687 13.1797 16.9913 13.8203 16.2355L13.0623 15.7503C12.6215 16.2734 12.0006 16.6313 11.2813 16.6313Z" />
      <path d="M15.5626 8.68742H6.30808V9.77023H15.5626V8.68742Z" />
      <path d="M11.5196 6.03594H6.30808V7.11875H11.5196V6.03594Z" />
    </SvgIcon>
  )
}

export function ContactsIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M3.85904 20V15.7651H2.9281V14.7041H3.85904V11.5302H2.9281V10.4698H3.85904V7.29594H3.02162V6.23492H3.85974V2H19.0719V20H3.85904ZM7.8999 18.9383H18.0115V3.06102H7.8999V18.9383ZM4.92005 18.9383H6.83748V3.06102H4.92005V6.23492H5.8531V7.29594H4.92005V10.4698H5.8531V11.5302H4.92005V14.7041H5.8531V15.7651H4.92005V18.9383Z" />
      <path d="M9.13318 14.1971V13.7633C9.13318 13.0545 9.39474 12.3662 9.88974 11.7734C10.2895 11.3013 10.7903 10.925 11.3551 10.6723C10.9957 10.3552 10.7366 9.94029 10.6094 9.47826C10.4821 9.01623 10.4923 8.52714 10.6386 8.07078C10.7905 7.5789 11.0957 7.14846 11.5096 6.84234C11.9235 6.53622 12.4244 6.37044 12.9392 6.36922H12.9645C13.4838 6.37527 13.9873 6.5489 14.3999 6.86425C14.8126 7.1796 15.1124 7.6198 15.2546 8.1193C15.3925 8.57833 15.3934 9.06766 15.2571 9.52719C15.1209 9.98673 14.8534 10.3965 14.4875 10.7061C15.0579 10.9633 15.5663 11.3403 15.9781 11.8114C16.4815 12.4006 16.7515 13.077 16.7515 13.7633V14.1971H9.13318ZM15.5408 13.1213C15.1737 12.2523 14.1296 11.4148 12.8731 11.4148C11.9042 11.4148 10.6934 12.0948 10.313 13.1241L15.5408 13.1213ZM12.9392 7.44429C12.6659 7.43927 12.3973 7.51572 12.1676 7.66391C11.9379 7.8121 11.7575 8.02531 11.6494 8.27639C11.5413 8.52747 11.5104 8.80504 11.5606 9.07375C11.6108 9.34245 11.7399 9.59012 11.9314 9.78519C12.1229 9.98027 12.3681 10.1139 12.6359 10.1691C12.9036 10.2243 13.1817 10.1986 13.4347 10.0952C13.6878 9.99176 13.9043 9.81536 14.0567 9.58844C14.2091 9.36153 14.2906 9.09437 14.2906 8.82101C14.2934 8.4594 14.1527 8.11143 13.8994 7.85336C13.6461 7.5953 13.3008 7.44819 12.9392 7.44429Z" />
    </SvgIcon>
  )
}

export function CheckboxIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M20 20H2V2H20V20ZM3.05386 18.9461H18.9461V3.05386H3.05386V18.9461Z" />
    </SvgIcon>
  )
}

export function CheckboxSelectedIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M2 2V20H20V2H2ZM9.00468 15.0539L5.63934 11.6885L6.38407 10.9368L9.00468 13.5574L15.6089 6.95316L16.3607 7.69789L9.00468 15.0539Z" />
    </SvgIcon>
  )
}

export function FilterIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <path d="M2 3.52539V4.39867L8.92859 11.8595V19.4751L13.0714 17.4009V11.8595L20 4.39867V3.52539H2ZM12.0167 16.7491L9.98328 17.7672V12.2301H12.0167V16.7491ZM12.2656 11.1754H9.73437L3.60875 4.58008H18.3905L12.2656 11.1754Z" />
    </SvgIcon>
  )
}

export function ProfileIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconProfile style={{ color, width, height }} />
}

export function RoundCheckFilledIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconRoundCheckFilled style={{ color, width, height }} />
}

export function CloseRoundedFilledIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconCloseRoundedFilled style={{ color, width, height }} />
}

export function UserFilledIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconUserFilled style={{ color, width, height }} />
}

export function HelpIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconHelp style={{ color, width, height }} />
}

export function ExchangeIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconExchange style={{ color, width, height }} />
}

export function CloseRoundedIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconCloseRounded style={{ color, width, height }} />
}

export function RoundCheckIcon({ color, width, height }: IconPropsSvgUse): JSX.Element {
  return <IconRoundCheck style={{ color, width, height }} />
}
